import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import DisplayDateCovidNew from '../../components/DisplayDateCovid/DisplayDateCovidNew'
import Spinner from '../../components/Loader/Spinner'
import EmptyMap from '../../components/Map/emptyMap'
import Timeline from '../../components/Timeline'
import Map from '../../components/Map'
// import MapCollection from '../../components/MapCollection'
import toolTipFormatter from './toolTipFormatter'
import MapLegend from './cdcMapLegend8LevelHorizontal'
import SideTable from './SideTable'
import styles from './MapPage.module.scss'
import ErrorLogs from '../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../components/AuthProvider'
import { lastweekEndDate } from './dates'
const DashboardMap = ({ zoomLocation }) => {
  const { user } = useAuthState()
  const chartRef = useRef(null)
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const location = useLocation()
  const hash = location.hash
  const [getMapStates, setMapStates] = useState()
  const [activeCbsa, setActiveCbsa] = useState()
  const [metros, setMetros] = useState()
    const [zip3, setZip3] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const [getCBSAJsonData, setCBSAJsonData] = useState()
  const [getZip3JsonData, setZip3JsonData] = useState()
  const [getActiveZip3, setActiveZip3] = useState()
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    setExportButtonEnable,
    setDisplayDate
  } = useGeoState()
  
  var geo_parent='US'

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }
  const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'utimap',
    'STATE',
    false,
    {geo_parent:'US'}
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) { 
        var datacount= Object.keys(statesData.response_data).length-1                
        setDisplayDate(Object.keys(statesData.response_data).sort()[datacount])       
        setMapStates(statesData.response_data)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesData])

  const { data: msaData, error: MapmsaError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'utimap',
    'MSA',false,{geo_parent:'US'}
  )

  useEffect(() => {
    if (msaData !== null && msaData !== undefined) {
      if (msaData.response_code === 200) {   
        setExportButtonEnable(true)    
        setMetros(msaData.response_data)
      } else if (msaData.response_code === 404) {
        setMetros(msaData.response_data)
        ErrorLogs({
          message_type: 'Error',
          error_details: `${msaData.response_subject}, ${msaData.response_message},for ${geo_parent}`,
          user: user,
        })
      } else {
        setErrorCode(msaData.response_code)
        setErrorMessage(msaData.response_message)
        setErrorSubject(msaData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [msaData])

  const { data: zip3Data, error: MapZip3Error } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'utimap',
    'ZIP3',false,{geo_parent:'US'}
  )

  useEffect(() => {
    if (zip3Data !== null && zip3Data !== undefined) {
      if (zip3Data.response_code === 200) {     
        setZip3(zip3Data.response_data)
      } else if (zip3Data.response_code === 404) {
        setZip3(zip3Data.response_data)
        ErrorLogs({
          message_type: 'Error',
          error_details: `${zip3Data.response_subject}, ${zip3Data.response_message},for ${geo_parent}`,
          user: user,
        })
      } else {
        setErrorCode(zip3Data.response_code)
        setErrorMessage(zip3Data.response_message)
        setErrorSubject(zip3Data.response_subject)
        seterrorOccured(true)
      }
    }
  }, [zip3Data])


  // Active Metro Areas
  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'utiactivelocations',
    '',
    false,
    {disease_type:'UTI',geo_type:'MSA',geo_parent_code:'NA'} 
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      setActiveCbsa(activeCbsasData.response_data)
    }
  }, [activeCbsasData])

  // Active Metro Areas
    const { data: activeZip3sData, error: aactiveZip3sDataError } = useGeoFetch(
      dataStartDate,
      dataEndDate,
      'utiactivelocations',
      '',
    false,
    {disease_type:'UTI',geo_type:'ZIP3',geo_parent_code:'NA'} 
    )
    useEffect(() => {
      if (activeZip3sData !== null && activeZip3sData !== undefined) {
        if (activeZip3sData.response_code === 200) {
          if (Object.keys(activeZip3sData.response_data).length > 0)
            setActiveZip3(activeZip3sData.response_data)
        } else {
          setErrorCode(activeZip3sData.response_code)
          setErrorMessage(activeZip3sData.response_message)
          setErrorSubject(activeZip3sData.response_subject)
          seterrorOccured(true)
        }
      }
      //setMetros(cbsaData)
    }, [activeZip3sData])
  
  //const lastweekEndDate = dayjs().day(-1).format('YYYY-MM-DD')

  useEffect(() => {
    let url = `${window.location.origin}/rsv/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/rsv/cb_2018_us_cbsa_20m_wkid102004.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file cb_2018_us_cbsa_20m_wkid102004.json ')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/flu/three_dig_zips.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setZip3JsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file three_dig_zips.json ')
      })
  }, [1])
  if ( MapError || errorOccured||MapmsaError||activeCbsasDataError || MapZip3Error) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'state' && (
            <>
              {getMapStates !== undefined ? (
                <SideTable stateData={getMapStates} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
          {regionSelected === 'metro' && (
            <>
              {metros !== undefined ? (
                <SideTable stateData={metros} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
           {regionSelected === 'zip3' && (
            <>
              {zip3 !== undefined ? (
                <SideTable stateData={zip3} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className={`${styles.map}`}>
        {regionSelected === 'state' && (
          <>
            {getMapStates !== undefined && getStateJson ? (
              <>
                <div className={`${styles.providerHeader}`}>
                   <DisplayDateCovidNew
                    statesData={getMapStates}
                    showWeek={true}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    diseaseType={''}
                  />
                  <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={5}
                    loadError={MapError}
                  />
                </div>
                <div className={styles.legendDiv}>
                <MapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="RSVMAP"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="uti"
                  mapTitleDisable={true}
                />

               
              </>
            ) : (
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
        {regionSelected === 'metro' && (
          <>
            {metros !== undefined &&
            getMapStates !== undefined &&
            activeCbsa !== undefined &&
            getCBSAJsonData ? (
              <>
               <div className={`${styles.providerHeader}`}>
               <DisplayDateCovidNew
                    statesData={getMapStates}
                    showWeek={true}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    diseaseType={''}
                  />
                  <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={5}
                    loadError={MapError}
                  />
               </div>
               <div className={styles.legendDiv}>
                <MapLegend />
                </div>
              <Map
              toolTipFormatter={toolTipFormatter}
              activeCbsasData={activeCbsa}
              statesData={getMapStates}
              cbsaData={metros}
              mapOptions={mapOptions}
              dynamicMapTitle={true}
              mapType="RSVMAPMSA"
              enableButtons={true}
              zoomLocation={zoomLocation}
              chartRef={chartRef}
              mapDataType={1}
              JsonData={getCBSAJsonData}
              stateJson={getStateJson}
              dashboardType="uti"
              mapTitleDisable={true}
            />
              </>
            ) : (
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
        {regionSelected === 'zip3' && (
          <>
            {zip3 !== undefined &&
            getMapStates !== undefined &&
            activeZip3sData !== undefined &&
            getZip3JsonData ? (
              <>
               <div className={`${styles.providerHeader}`}>
               <DisplayDateCovidNew
                    statesData={getMapStates}
                    showWeek={true}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    diseaseType={''}
                  />
                  <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={5}
                    loadError={MapError}
                  />
               </div>
               <div className={styles.legendDiv}>
                <MapLegend />
                </div>
              <Map
              toolTipFormatter={toolTipFormatter}
              activeCbsasData={null}
                activeZip3Data={getActiveZip3}
                statesData={getMapStates}
                cbsaData={null}
              mapOptions={mapOptions}
              dynamicMapTitle={true}
               mapType="ZIP3MAP"
              enableButtons={true}
              zoomLocation={zoomLocation}
              chartRef={chartRef}
              mapDataType={1}
              toggleEnabled={true}
              zip3Json={getZip3JsonData}
              stateJson={getStateJson}
              dashboardType="uti"
              mapTitleDisable={true}
              zip3Data={zip3}
              
            />
              </>
            ) : (
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
